"use client";
import * as React from "react";
import { useState, useEffect } from "react";

function ProductOverview() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative py-16 lg:py-20 bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/40 overflow-hidden" aria-labelledby="product-overview-heading">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
        <div className="absolute top-1/4 left-1/4 w-72 h-72 lg:w-80 lg:h-80 md:w-60 md:h-60 sm:w-40 sm:h-40 bg-blue-200/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-72 h-72 lg:w-80 lg:h-80 md:w-60 md:h-60 sm:w-40 sm:h-40 bg-indigo-200/20 rounded-full blur-3xl"></div>
      </div>

      <div className="container max-w-7xl mx-auto px-4 lg:px-6 md:px-4 sm:px-3 relative">
        <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          {/* Two Column Layout */}
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 md:gap-8 sm:gap-6 items-center">

            {/* Left Content */}
            <div className="order-1 lg:order-1">
              <header className="text-left">
                <div className="inline-flex items-center px-4 py-2 lg:px-6 lg:py-2 md:px-4 md:py-1.5 sm:px-3 sm:py-1 bg-[#1719A8]/90 backdrop-blur-md border border-[#1719A8]/60 rounded-full mb-4 lg:mb-6 shadow-lg">
                  <span className="w-2 h-2 bg-white rounded-full mr-3 animate-pulse"></span>
                  <span className="text-xs md:text-sm lg:text-sm sm:text-xs text-white font-semibold uppercase tracking-wider">
                    About BaBe
                  </span>
                </div>

                <h2 id="product-overview-heading" className="text-3xl lg:text-5xl md:text-3xl sm:text-2xl font-bold text-slate-900 mb-4 lg:mb-3 leading-normal ">
                  Comprehensive Luggage
                  <span className="block leading-normal bg-gradient-to-r from-orange-500 via-yellow-500 to-green-500 bg-clip-text text-transparent">
                    Tracking Solution
                  </span>
                </h2>

                <div className="space-y-4 lg:space-y-6 text-lg lg:text-xl md:text-base sm:text-sm text-slate-600 leading-relaxed">
                  <p>
                    Baggy Beach well known as BaBe offers the solution for luggage at airports connecting between the United States of America locations irrespective of the service provider, addressing the huge loss or late of luggage arrival for the traveler from source, as the customer is facing delay in picking the luggage.
                  </p>
                  <p>
                    This is addressed by means of web and mobile application in smooth movement of luggage movement between the airlines and airports in a safety and secure manner. BaBe software is a comprehensive, next generation, ready-to-use Solution for individual as end User.
                  </p>
                </div>
              </header>
            </div>

            {/* Right Image */}
            <div className="order-2 lg:order-2">
              <div className="relative w-full">
                <div className="relative h-64 md:h-80 lg:h-96 bg-gradient-to-r from-[#D96F2B]/90 to-[#C9C51A]/90 backdrop-blur-md border border-white/30 rounded-3xl overflow-hidden shadow-2xl group">
                  <img
                    src="https://cdn.acsdev.in/Vasta/product1.png"
                    alt="BaBe luggage tracking system interface"
                    className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 "></div>
                  <div className="absolute bottom-4 lg:bottom-6 left-4 lg:left-6 right-4 lg:right-6">
                    <h3 className="text-xl lg:text-2xl font-bold text-white mb-2">BaBe Boarding Pass</h3>
                    <p className="text-white/80 text-sm lg:text-base">
                      Comprehensive luggage tracking and management system designed for airports and airlines
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default ProductOverview;
